import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import CEONavigation from './CEONavigation';
import CEODashboardPage from '../pages/CEODashboardPage';
import CEOEnrolledGymsPage from '../pages/CEOEnrolledGymsPage';
import CEOEnrollmentPage from '../pages/CEOEnrollmentPage';

const CEOPortal: React.FC = () => {
  const { user } = useAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');

  // Redirect to regular admin if not CEO
  useEffect(() => {
    if (user && !user.is_ceo) {
      // This would redirect to the regular admin portal
      console.log('User is not CEO, redirecting to regular admin portal');
    }
  }, [user]);

  if (!user || !user.is_ceo) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">🚫</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-gray-600">You don't have permission to access the CEO portal.</p>
        </div>
      </div>
    );
  }

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <CEODashboardPage onNavigate={setCurrentPage} />;
      case 'gyms':
        return <CEOEnrolledGymsPage />;
      case 'enrollment':
        return <CEOEnrollmentPage />;
      default:
        return <CEODashboardPage onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-orange-900 to-blue-900">
      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <CEONavigation currentPage={currentPage} onNavigate={setCurrentPage} />
      </div>

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Page content */}
        <main className="py-6 relative z-10">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {renderCurrentPage()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default CEOPortal;
